export default {
  step: {
    tipoPantalla: null,
    pregunta: null,
    subpregunta: null,
    textoAyuda: null,
    textoAyudaTitulo: null,
    infoAdicionalTitulo: null,
    infoAdicional: null,
    idPresupuesto: null,
    numPresupuesto: null,
    idMarca: null,
    idModelo: null,
    idVersion: null,
    posiblesRespuestas: null,
    productos: null,
    resumen: null,
    datosIdentificacion: null,
    grupoNavegacion: null,
    fechaDefault: null,
    tipoAutomovil: null
  },
  select: [],
  imagenBytes: null
};
